import { Link, useParams } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { articleList } from "@/mocks/articles";

export default function ArticleDetail() {
  const { id } = useParams();
  const article = articleList.find((a) => a.id === id) ?? articleList[0];
  const others = articleList.filter((a) => a.id !== article.id).slice(0, 3);

  return (
    <>
      <Navbar />
      <main>
        <section className="pt-24 md:pt-28">
          <div className="mx-auto w-full max-w-7xl px-4 md:px-6 py-8 md:py-12">
            <nav aria-label="面包屑" className="text-xs text-foreground-500">
              <Link to="/" className="hover:text-primary-700">首页</Link>
              <span className="mx-1.5">/</span>
              <span className="text-foreground-700">追番指南</span>
              <span className="mx-1.5">/</span>
              <span className="text-foreground-700">{article.tag}</span>
            </nav>

            <div className="mx-auto mt-8 max-w-3xl">
              <span className="w-fit rounded-full bg-secondary-100 px-3 py-1 text-xs text-secondary-900">{article.tag}</span>
              <h1 className="mt-4 font-heading text-2xl leading-tight text-foreground-950 md:text-3xl">{article.title}</h1>
              <div className="mt-4 flex flex-wrap items-center gap-x-4 gap-y-2 text-xs text-foreground-500">
                <span className="inline-flex items-center gap-1">
                  <i className="ri-calendar-line" aria-hidden="true" />
                  {article.date}
                </span>
                <span className="inline-flex items-center gap-1">
                  <i className="ri-time-line" aria-hidden="true" />
                  约 {article.readMin} 分钟读完
                </span>
                <span className="inline-flex items-center gap-1">
                  <i className="ri-edit-line" aria-hidden="true" />
                  小水编辑部
                </span>
              </div>

              <div className="mt-6 aspect-[16/9] w-full overflow-hidden rounded-2xl">
                <img src={article.image} alt={article.title} className="h-full w-full object-cover" />
              </div>

              <article className="mt-8">
                {article.content.map((para, i) => (
                  <p key={i} className="mb-5 text-[15px] leading-8 text-foreground-700">
                    {para}
                  </p>
                ))}
              </article>

              <div className="mt-8 flex flex-wrap items-center justify-between gap-4 border-t border-background-200 pt-6">
                <p className="text-sm text-foreground-600">觉得有用？分享给同样爱追短番的朋友吧</p>
                <Link
                  to="/library"
                  className="inline-flex items-center gap-2 rounded-full bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 whitespace-nowrap transition-colors hover:bg-primary-600"
                >
                  <i className="ri-movie-2-line" aria-hidden="true" />
                  去挑一部短番
                </Link>
              </div>
            </div>
          </div>
        </section>

        <section className="bg-background-100/70">
          <div className="mx-auto w-full max-w-7xl px-4 md:px-6 py-12 md:py-16">
            <h2 className="font-heading text-2xl text-foreground-950">更多追番指南</h2>
            <div className="mt-6 grid gap-6 md:grid-cols-3">
              {others.map((o) => (
                <Link
                  key={o.id}
                  to={`/article/${o.id}`}
                  className="group flex flex-col overflow-hidden rounded-2xl border border-background-200/70 bg-background-50 transition-all hover:-translate-y-1 hover:border-accent-200"
                >
                  <div className="aspect-[16/9] w-full overflow-hidden">
                    <img src={o.image} alt={o.title} loading="lazy" className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
                  </div>
                  <div className="p-5">
                    <h3 className="font-heading text-base leading-snug text-foreground-950 group-hover:text-primary-700 transition-colors">{o.title}</h3>
                    <p className="mt-2 line-clamp-2 text-sm text-foreground-600">{o.summary}</p>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}